// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"afe877d5","787":"ba5a44db"}[chunkId] + ".chunk.js";
};